import React from 'react'
import * as C from './styles'

const H2 = ({title}) => {
  return (
    <C.H2>{title}</C.H2> 
  )
}

export default H2